<template>
  <v-dialog v-model="open" persistent max-width="720px">
    <v-card>
      <v-card-title>
        <span class="headline">Nota obciążeniowa {{ note.number }}</span>
      </v-card-title>
      <v-card-text v-if="loaded">
        <v-container class="pt-0" grid-list-md>
          <v-layout wrap>
            <v-flex xs12 sm6>
              <div class="caption grey--text">Nr noty</div>
              <div>{{ note.number }}</div>
            </v-flex>
            <v-flex xs12 sm6>
              <div class="caption grey--text">Data wystawienia</div>
              <div>{{ note.issued_at ? moment(note.issued_at).format('DD-MM-YYYY') : '—' }}</div>
            </v-flex>
            <v-flex xs12 sm6>
              <div class="caption grey--text">Odbiorca</div>
              <div>{{ note.recipient && (note.recipient.company_name || ((note.recipient.first_name || '') + ' ' + (note.recipient.last_name || '')).trim()) || '—' }}</div>
            </v-flex>
            <v-flex xs12 sm6>
              <div class="caption grey--text">NIP</div>
              <div>{{ (note.recipient && note.recipient.nip) || '—' }}</div>
            </v-flex>
            <v-flex xs12 sm6>
              <div class="caption grey--text">Adres</div>
              <div>{{ recipientAddress }}</div>
            </v-flex>
            <v-flex xs12 sm6>
              <div class="caption grey--text">Metoda płatności</div>
              <div>{{ (note.payment && note.payment.method_label) || '—' }}</div>
            </v-flex>
            <v-flex xs12 sm6>
              <div class="caption grey--text">Termin zapłaty</div>
              <div>{{ note.due_date || '—' }}</div>
            </v-flex>
            <v-flex xs12 sm6>
              <div class="caption grey--text">Kwota</div>
              <div><strong>PLN {{ note.total_amount }}</strong></div>
            </v-flex>

            <v-flex xs12 class="mt-3">
              <div class="subheading">Vouchery</div>
              <v-data-table
                :headers="voucherHeaders"
                :items="note.vouchers || []"
                hide-actions
                class="elevation-1 mt-2"
              >
                <template slot="items" slot-scope="props">
                  <td>#{{ props.item.voucher_number }}</td>
                  <td>{{ props.item.service_type }}</td>
                  <td>PLN {{ props.item.price }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click="$emit('printPDF', note.id)">
          <v-icon size="15px" class="mr-1">fas fa-print</v-icon> Drukuj
        </v-btn>
        <v-btn flat @click="$emit('downloadPDF', note.id, note.number)">
          <v-icon size="15px" class="mr-1">fas fa-download</v-icon> Pobierz PDF
        </v-btn>
        <v-btn color="grey darken-1" flat @click="$router.push({ name: 'DebitNotes' })">Zamknij</v-btn>
        <v-btn color="blue darken-1" flat
               @click="$router.push({ name: 'EditDebitNote', params: { noteId: note.id } })">
          Edytuj
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapActions } from 'vuex';

  export default {
    name: 'DebitNoteDetails',
    data() {
      return {
        open: true,
        loaded: false,
        note: {},
        voucherHeaders: [
          { text: 'Nr vouchera', value: 'voucher_number' },
          { text: 'Opis usługi', value: 'service_type', sortable: false },
          { text: 'Wartość', value: 'price' },
        ],
      };
    },
    mounted() {
      this.fetchNoteDetails(this.$route.params.noteId)
        .then((response) => {
          this.note = response;
          this.loaded = true;
        });
    },
    computed: {
      recipientAddress() {
        const r = this.note.recipient || {};
        const street = [r.street, r.building_no, r.flat_no ? `/${r.flat_no}` : null].filter(Boolean).join(' ');
        const city = [r.postal_code, r.city].filter(Boolean).join(' ');
        return [street, city].filter(Boolean).join(', ') || '—';
      },
    },
    methods: {
      ...mapActions('DebitNoteStore', ['fetchNoteDetails']),
    },
  };
</script>
